import CustomSelect from '../UI/CustomSelect';
import MenuItem from '@mui/material/MenuItem';
import { setCookie } from '../../utils';
import { getOptionLabelDependingOnLabelKeys } from '../../utils/componentUtils';

export type CookieSelectProps<T = string> = {
    selectedValue: T;
    options: any[];
    onChange: (selectedValue: T) => void;
    valueKey: string;
    labelKeys: string[];
    label: string;
    cookieName: string;
};

function CookieSelect<T>({
    selectedValue,
    options,
    onChange,
    valueKey,
    labelKeys,
    label,
    cookieName,
    ...props
}: CookieSelectProps<T>) {
    const handleChange = (value: T) => {
        setCookie(cookieName, value, 1000);
        onChange(value);
    };

    return (
        <CustomSelect selectedValue={selectedValue} options={options} onChange={handleChange} label={label} {...props}>
            {options &&
                options.map((option) => (
                    <MenuItem value={option[valueKey]} key={option[valueKey]}>
                        <span className="notranslate">{getOptionLabelDependingOnLabelKeys(option, labelKeys)}</span>
                    </MenuItem>
                ))}
        </CustomSelect>
    );
}

export default CookieSelect;
